// Need to use the React-specific entry point to import createApi
import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { setCredentials } from "./slices/authSlice"
// Define a service using a base URL and expected endpoints

export const authApi = createApi({
  reducerPath: "authApi",
  baseQuery: fetchBaseQuery({ baseUrl: `${process.env.REACT_APP_BACKEND_API_URL}/api/` }),
  endpoints: (builder) => ({
    login: builder.mutation({
        query: (user) => ({
            url: 'auth/login',
            method: 'POST',
            body: user
        }),
    }),
    register: builder.mutation({
        query: (user) => ({
            url: 'auth/register',
            method: 'POST',
            body: user
        }),
    }),
    forgotPassword: builder.mutation({
        query: (user) => ({
            url: 'auth/forgotPassword',
            method: 'POST',
            body: user
        }),
    }),
    resetPassword: builder.mutation({
        query: (user) => ({
            url: `auth/resetPassword/${user._id}/${user.uniqueString}`,
            method: 'PUT',
            body: user
        }),
    }),
    changeEmail: builder.mutation({
        query: (user) => ({
            url: `auth/changeEmail`,
            method: 'POST',
            body: user
        }),
    }),
    changePassword: builder.mutation({
        query: (user) => ({
            url: `auth/changePassword`,
            method: 'POST',
            body: user
        }),
    }),
    refresh: builder.mutation({
        query: () => ({
            url: '/auth/refresh',
            method: 'GET',
        }),
        async onQueryStarted(arg, { dispatch, queryFulfilled }) {
            try {
                const { data } = await queryFulfilled
                console.log(data)
                const { accessToken } = data
            } catch (err) {
                console.log(err)
            }
        }
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const { useLoginMutation, useRegisterMutation, useResetPasswordMutation, useForgotPasswordMutation, useChangeEmailMutation, useChangePasswordMutation, useRefreshMutation, } = authApi;